import { Overlay } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { DownloadMedicalGuideComponent } from '../components/modals/download-medical-guide/download-medical-guide.component';
import { ErrorServerComponent } from '../components/modals/error-server/error-server.component';
import { FilterModalComponent } from '../components/modals/filter-modal/filter-modal.component';
import { IdentifyUserModalComponent } from '../components/modals/identify-user-modal/identify-user-modal.component';
import { InfoModalComponent } from '../components/modals/info-modal/info-modal.component';
import { MedicalGuide } from '../models/api';
import { ContextService } from './ctx.service';
import { ErrorIdentifyUserModalComponent } from '../components/modals/error-identify-user-modal/error-identify-user-modal.component';

export function capitalize(str: string): string {
  if (!str) return '';
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

@Injectable({
  providedIn: 'root'
})
export class UiService {

  downLoadMedicalGuideDialogRef: MatDialogRef<DownloadMedicalGuideComponent>;
  errorIdentifyUserDialogRef: MatDialogRef<ErrorIdentifyUserModalComponent>;
  indetifyUseDialogRef: MatDialogRef<IdentifyUserModalComponent>;
  private showSpinner$: BehaviorSubject<boolean>;


  constructor(
    public dialog: MatDialog,
    private overlay: Overlay,
    private utils: ContextService,
  ) {
    this.showSpinner$ = new BehaviorSubject<boolean>(false);
  }


  closeAllDialogs() {
    this.dialog.closeAll();
  }

  checkSpinner() {
    return this.showSpinner$.asObservable();
  }

  showSpinner() {
    this.showSpinner$.next(true);
  }

  stopSpinner() {
    this.showSpinner$.next(false);
  }

  openDownloadMedicaGuideModal(medicalGuide: MedicalGuide) {
    this.downLoadMedicalGuideDialogRef = this.dialog.open(DownloadMedicalGuideComponent, {
      panelClass: 'download-medical-guide',
      maxHeight: this.utils.isMobile ? '94vh' : '82vh',
      maxWidth: this.utils.isMobile ? '90vw' : '1000px',
      width: this.utils.isMobile ? '90vw' : '60vw',
      height: this.utils.isMobile ? '94vh' : 'auto',
      data: {
        medicalGuide
      }
    });
  }

  openServerErrorModal() {
    this.dialog.open(ErrorServerComponent, {
      panelClass: 'server-error-modal',
      maxHeight: this.utils.isMobile ? '52vh' : '82vh',
      maxWidth: this.utils.isMobile ? '90vw' : '60vw',
      width: this.utils.isMobile ? '90vw' : 'auto',
      height: this.utils.isMobile ? '52vh' : 'auto'
    });
  }
  
  openModalDownloadPdf() {
    this.downLoadMedicalGuideDialogRef = this.dialog.open(DownloadMedicalGuideComponent, {
      panelClass: 'download-medical-guide',
      maxHeight: this.utils.isMobile ? '70vh' : '38vh',
      maxWidth: this.utils.isMobile ? '90vw' : '45vw',
      width: this.utils.isMobile ? '90vw' : '45vw',
      height: this.utils.isMobile ? '70vh' : '38vh',
    })
  }

  openerrorIdentifyUserModalComponent() {
    this.errorIdentifyUserDialogRef = this.dialog.open(ErrorIdentifyUserModalComponent, {
      panelClass: 'error-identify-user'
    })
  }

  isModalOpen(dialogRef: MatDialogRef<any>): boolean {
    return dialogRef?.getState() === 0;
  }

  openFilterModal() {
    const opts = {
      ...this.getDefaultModalDialogOpts(),
      panelClass: 'filter-modal',
    };
    const dialogRef = this.dialog.open(FilterModalComponent, opts);
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  openInfoModal() {
    const opts = {
      ...this.getDefaultModalDialogOpts(),
      height: '41%',
    };
    const dialogRef = this.dialog.open(InfoModalComponent, opts);
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  private getDefaultModalDialogOpts() {

    const opts = {
      maxHeight: '100vh',
      restoreFocus: false,
      enterAnimationDuration: '500ms',
      exitAnimationDuration: '500ms',
    };


    if (this.utils.isMobile) {
      return {
        ...opts,
        maxWidth: '100vw',
        height: '85%',
        width: '100%',
        position: {
          bottom: '0%',
        }
      };
    }

    return {
      ...opts,
      maxWidth: '422px',
      width: '422px',
      position: {
        top: '25vh',
        right: '10%'
      }
    };
  }
}


